const minimumOrfSizeSelector = (state) => state.minimumOrfSize;
export default minimumOrfSizeSelector;
